/* ScheduleComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ScheduleRenderer");
const ScheduleVeilComponent = require("../../../../../lib/actions/veils/schedule/ScheduleVeilComponent");
const _ = require("lodash");

class ScheduleComponent extends EventEmitter {
    constructor(input) {
        super();
        this._input = input;
        this._logger = this._input._logger;
        this._gameEditor = this._input._gameEditor;
        this._osPlanEntity = this._input._gameEditor.planEntity;
        this._plan = this._input._gameEditor.getPlan();
        this._modalUserFeedback = this._input._modalUserFeedback;
        this._userSession = this._input._userSession;
        // this._triggerTypeEntity = new TriggerTypeEntity(this._userSession.activeOrganization.id);
        this._triggerTypeScheduled = undefined;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "ScheduleComponent.shutdown() error.");
            }
        );
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }
    sendResponse(result) {
        this._context.resolve(result);
    }
    cancelAction() {
        this._context.reject({ userRejected: true });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    schedulePlan(workInput) {
        return this._modalUserFeedback
            .displayCustom(new ScheduleVeilComponent(this._logger, false, "Run OS Plan - Schedule", { firstTime: true }), { dontHide: true })
            .then((scheduleDef) => {
                this._modalUserFeedback.displayLoading();
                let schedule = scheduleDef.schedule;
                let description = workInput.description;
                let workInputObj = scheduleDef.workInput;
                // backdoor to allow every minute schedules for internal testing
                if (_.get(schedule, "every.hour") && name === "everymin") {
                    _.set(schedule, "every.minute", schedule.every.hour);
                    delete schedule.every.hour;
                }
                return this._plan.createPlanSchedule(description, "", schedule, workInputObj);
            })
            .then((result) => {
                this._triggerTypeScheduled = result;
                this.sendResponse(result);
            })
            .catch((err) => {
                if (!err.userRejected) {
                    if (this._logger) {
                        this._logger.warn(
                            {
                                error: err
                            },
                            "ScheduleComponent._schedulePlanWork() - Error"
                        );
                    } else {
                        console.error(err);
                    }
                    return this._modalUserFeedback.displayError(err);
                } else {
                    this._modalUserFeedback.hideDisplayed();
                }
            });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ScheduleComponent;
